// Libs
import React from 'react'
import axios from 'axios'
import { ArrowUpRight } from 'react-feather'

// CSS
import './styles.scss'

// Components
import Button from '../../../../components/Button'


const CaptureCardDocument = ({ documents, changeCardType, downloadFiles, loading }) => {
  // const sortedDocuments = documents.sort((a, b) => {
  //   if (b.type === 'Outros') {
  //     return -1;
  //   }
  //   if (b.type === 'Inicial') {
  //     return 1;
  //   }

  //   return 0;
  // })

  const captureAPI = 'https://capture.semprocesso.com.br/lawsuit/redirect'

  return (
    <div className="capture-card-document">
      <div className="capture-card-document__scroller-wrapper" style={{ gridArea: '1 / 1 / 5 / 8' }}>
        <span className="capture-card-document__scroller">
          {documents.map(document => (
            <div key={document._id} className="capture-card-document__wrapper">
              <div className="capture-card-document__file--wrapper">
                <span className="capture-card-document__hover">
                  <a href={`${captureAPI}/${encodeURIComponent(document.link)}`} target="_blank"><ArrowUpRight color="white" size="30px" /></a>
                </span>
                <iframe className="capture-card-document__file" src={`${captureAPI}/${encodeURIComponent(document.link)}`} title={document.type} />
              </div>
              <span className="capture-card-document__type">Tipo do Documento</span>
              <span className="capture-card-document__name">{document.type}</span>
            </div>
          ))}
        </span>
      </div>
      <div className='capture-card-insert__button--wrapper' style={{ gridArea: '5 / 6 / 6 / 7' }}>
        <Button
          resize={false}
          onClick={() => changeCardType('case')}>
          Voltar
        </Button>
      </div>
      <div className='capture-card-document__button--wrapper' style={{ gridArea: '5 / 7 / 6 / 8' }}>
        <Button
          type="submit"
          resize={false}
          localLoading={loading}
          onClick={downloadFiles}>
          Baixar
        </Button>
      </div>
    </div>
  )
}

export default CaptureCardDocument
